export default "__VITE_ASSET__9360baae__"